export default __webpack_public_path__ + "b73bfb228f5eb38ff397ab3b75be0b52.png";